// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   1. AIRDROPS MAIN PAGE STYLES (/airdrops)
   ========================================================================== */

.airdrops-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 40px 0 80px 0;
}

.airdrops-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
}

/* --- Hero Section --- */
.airdrops-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
    gap: 40px;
}

.airdrops-hero-content {
    flex: 1 1;
    max-width: 600px;
}

body.light_theme .participants-text strong {
    color: #000000;
}

.airdrop-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #D1AA67;
    margin-bottom: 12px;
}

.airdrop-badge-icon {
    font-size: 14px;
}

.airdrops-hero-title {
    font-size: 40px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 16px 0;
    line-height: 1.2;
}

.airdrops-hero-desc {
    font-size: 16px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 24px 0;
}

.airdrops-tabs {
    display: flex;
    gap: 10px;
}

.airdrop-tab {
    padding: 8px 20px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #6B7280;
    background-color: #E5E7EB;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.airdrop-tab.active {
    background-color: #D1AA67;
    color: #FFFFFF;
    font-weight: 600;
}

.airdrops-hero-image {
    width: 340px;
    max-width: 100%;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.airdrops-hero-image img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

/* --- Section Headers --- */
.airdrops-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.airdrops-section-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}

.airdrops-section-title {
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    margin: 0;
}

.airdrops-count-badge {
    background-color: #F3F4F6;
    color: #6B7280;
    font-size: 12px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 12px;
}

.airdrops-sort-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 8px;
    background-color: #E6E6E6;
    border: 1px solid #E5E7EB;
    font-size: 14px;
    font-weight: 600;
    color: #374151;
}

.airdrops-view-more {
    font-size: 14px;
    font-weight: 600;
    color: #D1AA67;
    text-decoration: none;
}

/* --- Active Grid Section --- */
.active-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 60px;
}

.airdrop-card {
    background-color: #FFFFFF;
    border: 1px solid #F0F0F0;
    border-radius: 18px;
    padding: 24px;
    box-shadow: 0 1px 8px rgb(0 0 0 / 9%);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.airdrop-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

.airdrop-card-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}

.airdrop-card-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.airdrop-card-avatar {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
    flex-shrink: 0;
}

.avatar-purple {
    background-color: #6366F1;
}

.avatar-gold {
    background-color: #D97706;
}

.avatar-teal {
    background-color: #0D9488;
}

.avatar-red {
    background-color: #EF4444;
}

.avatar-cyan {
    background-color: #06B6D4;
}

.avatar-grey {
    background-color: #6B7280;
}

.avatar-pink {
    background-color: #EC4899;
}

.airdrop-card-titles h3 {
    font-size: 17px;
    font-weight: 700;
    color: #101828;
    margin: 0 0 2px 0;
    line-height: 1.3;
}

.airdrop-card-titles p {
    font-size: 14px;
    color: #9CA3AF;
    margin: 0;
}

.status-badge {
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
}

.status-live {
    background-color: #DCFCE7;
    color: #059669;
}

.status-ended {
    background-color: #F3F4F6;
    color: #9CA3AF;
}

/* Tags */
.airdrop-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 20px;
}

.airdrop-tag {
    padding: 3px 8px;
    border-radius: 4px;
    color: #6A7282;
    font-size: 13px;
    background-color: #F9FAFB26;
    font-weight: 600;
}

body.light_theme .airdrop-tag {
    background-color: #F9FAFB;
}

.tag-sol {
    background-color: #f3e8ff26;
    color: #9333EA;
}

body.light_theme .tag-sol {
    background-color: #F3E8FF;
}

.tag-eth {
    background-color: #E0E7FF26;
    color: #4F46E5;
}

body.light_theme .tag-eth {
    background-color: #E0E7FF;
}

.tag-arb {
    background-color: #E0F2FE20;
    color: #0284C7;
}

body.light_theme .tag-arb {
    background-color: #E0F2FE;
}

.tag-token {
    background-color: #DCFCE7;
    color: #16A34A;
}

.tag-free {
    background-color: #F3F4F620;
    color: #4B5563;
}

body.light_theme .tag-free {
    background-color: #F3F4F6;
}

.tag-bnb {
    background-color: #FEF9C320;
    color: #CA8A04;
}

body.light_theme .tag-bnb {
    background-color: #FEF9C3;
}

.tag-carnival {
    background-color: #FFEDD520;
    color: #EA580C;
}

body.light_theme .tag-carnival {
    background-color: #FFEDD5;
}

.tag-stc {
    background-color: #FCE7F320;
    color: #E11D48;
}

body.light_theme .tag-stc {
    background-color: #FCE7F3;
}

.tag-nft {
    background-color: #ECE9FE;
    color: #7C3AED;
}

.tag-mint {
    background-color: #CCFBF120;
    color: #0D9488;
}

body.light_theme .tag-mint {
    background-color: #CCFBF1;
}

.tag-zeta {
    background-color: #E0F2FE20;
    color: #0369A1;
}

body.light_theme .tag-zeta {
    background-color: #E0F2FE;
}

.tag-layer1 {
    background-color: #F1F5F920;
    color: #475569;
}

body.light_theme .tag-layer1 {
    background-color: #F1F5F9;
}

/* Metrics */
.airdrop-metrics {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
    background-color: #fafafa08;
    padding: 12px;
    border-radius: 10px;
}

body.light_theme .airdrop-metrics {
    background-color: #FAFAFA;
}

.metric-group p {
    font-size: 14px;
    color: #9CA3AF;
    margin: 0 0 2px 0;
}

.metric-group h4 {
    font-size: 16px;
    font-weight: 700;
    color: #f3f3f3;
    margin: 3px 0 2px 0;
}

body.light_theme .metric-group h4 {
    color: #101828;
}

.metric-group span {
    font-size: 14px;
    color: #d4d4d4;
}

body.light_theme .metric-group span {
    color: #6B7280;
}

.participants-count {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 16px;
    font-weight: 700;
    color: #d1d1d1;
    justify-content: right;
}

body.light_theme .participants-count {
    color: #374151;
}

.participants-count i {
    font-size: 13px;
    color: #9CA3AF;
}

/* Action Button */
.airdrop-join-btn {
    width: 100%;
    padding: 11px 0;
    border-radius: 20px;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: background-color 0.2s ease;
}

.airdrop-join-btn:hover {
    background-color: #C09D5B;
}

/* --- Ended Grid Section --- */
.ended-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 60px;
}

.ended-card {
    background-color: #181a20;
    border: 1px solid #f3f4f617;
    border-radius: 14px;
    padding: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgb(0 0 0 / 12%);
}

body.light_theme .ended-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
}

.ended-card-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.ended-avatar {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 700;
    flex-shrink: 0;
}

.ended-info h4 {
    font-size: 14px;
    font-weight: 600;
    color: #e9e9e9;
    margin: 0 0 2px 0;
    line-height: 1.3;
}

body.light_theme .ended-info h4 {
    color: #111827;
}

.ended-info p {
    font-size: 14px;
    color: #9CA3AF;
    margin: 0;
}

/* --- Partner Banner Section --- */
.airdrop-partner-banner {
    background: linear-gradient(135deg, #ebecee0f 0%, #e2e4e712 100%);
    border-radius: 20px;
    padding: 40px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-top: 140px;
}

body.light_theme .airdrop-partner-banner {
    background: linear-gradient(135deg, #EBECEE 0%, #E2E4E7 100%);
}

.partner-banner-content {
    max-width: 500px;
    z-index: 2;
}

.partner-banner-subtitle {
    font-size: 14px;
    font-weight: 700;
    color: #d4d4d4;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

body.light_theme .partner-banner-subtitle {
    color: #303030;
}

.partner-banner-title {
    font-size: 28px;
    font-weight: 800;
    color: #fafafa;
    margin: 0 0 12px 0;
    line-height: 1.3;
}

body.light_theme .partner-banner-title {
    color: #111827;
}

.partner-banner-desc {
    font-size: 16px;
    color: #b4b4b4;
    margin: 0;
}

body.light_theme .partner-banner-desc {
    color: #4B5563;
}

.partner-banner-image {
    width: 380px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    position: absolute;
    right: 30px;
    bottom: 30px;
}

.partner-banner-image img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   2. AIRDROP DETAILS PAGE STYLES (/airdrop-detail)
   ========================================================================== */

.airdrop-details-page {
    background-color: #FFFFFF;
    color: #111827;
    padding: 80px 0px;
    min-height: 100vh;
}

.airdrop-details-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
}

/* --- Breadcrumb --- */
.airdrop-breadcrumb {
    font-size: 13px;
    color: #9CA3AF;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.airdrop-breadcrumb .breadcrumb-link {
    color: #D1AA67;
    text-decoration: none;
    transition: color 0.2s ease;
}

/* .airdrop-breadcrumb .breadcrumb-link:hover {
    color: #111827;
} */

.airdrop-breadcrumb .breadcrumb-sep {
    color: #D1D5DB;
}

.airdrop-breadcrumb .breadcrumb-current {
    color: #6B7280;
    font-weight: 500;
}

/* --- Hero Section --- */
.airdrop-detail-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 60px;
    gap: 40px;
}

.airdrop-detail-hero-left {
    flex: 1 1;
    max-width: 650px;
}

.airdrop-detail-title {
    font-size: 60px;
    font-weight: 700;
    color: #111827;
    line-height: 1.15;
    margin: 0 0 16px 0;
}

.gold-gradient-text {
    color: #D1AA67;
    font-weight: 800;
}

.airdrop-detail-desc {
    font-size: 16px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 32px 0;
}

/* --- Countdown Timer --- */
.airdrop-countdown-wrap {
    margin-bottom: 24px;
}

.countdown-label {
    display: block;
    font-size: 13px;
    color: #6B7280;
    margin-bottom: 10px;
    font-weight: 500;
}

.countdown-boxes {
    display: flex;
    gap: 12px;
}

.timer-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.timer-val {
    background-color: #F5F5F5;
    border: 1px solid #D1D1D1;
    border-radius: 14px;
    width: 64px;
    height: 64px;
    box-shadow: inset 0 0px 10px rgba(0, 0, 0, 0.2);
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    color: #D1AA67;
    line-height: 1.1;
}

.timer-unit {
    font-size: 14px;
    color: #9CA3AF;
    font-weight: 500;
    margin-top: 4px;
}

/* --- Meta Row: Participants & Rules --- */
.airdrop-meta-row {
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 14px;
}

.participants-text {
    color: #6B7280;
    display: flex;
    align-items: center;
    gap: 6px;
}

.participants-text strong {
    color: #f3f3f3;
}

body.light_light .participants-text strong {
    color: #111827;
}

.event-rules-link {
    color: #D1AA67;
    font-weight: 600;
    text-decoration: none;
    transition: opacity 0.2s ease;
}

.event-rules-link:hover {
    opacity: 0.8;
    color: #D1AA67;
}

/* --- Hero Right Image --- */
.airdrop-detail-hero-right {
    flex: 1 1;
    max-width: 610px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.airdrop-detail-img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}

/* --- Web3 Newbie Reward Tasks Section --- */
.airdrop-tasks-section {
    margin-top: 100px;
}

.tasks-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.tasks-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.tasks-section-title {
    font-size: 34px;
    font-weight: 600;
    color: #101828;
    margin: 0;
}

.badge-ongoing {
    background-color: #DCFCE7;
    color: #059669;
    font-size: 13px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 12px;
}

.view-rules-link {
    font-size: 13.5px;
    color: #D1AA67;
    font-weight: 600;
    text-decoration: none;
}

.view-rules-link:hover {
    color: #c59d57;
}

/* --- Tasks Cards List --- */
.tasks-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.task-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 16px;
    padding: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.task-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.task-card-left {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.task-num-badge {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #D1AA6730;
    color: #D1AA67;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
}

.task-info {
    display: flex;
    flex-direction: column;
}

.task-title {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 6px 0;
}

.task-desc {
    font-size: 13.5px;
    color: #9CA3AF;
    margin: 0 0 10px 0;
    line-height: 1.4;
    max-width: 600px;
}

.task-progress {
    font-size: 12px;
    font-weight: 600;
    color: #6B7280;
}

.task-card-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: column;
}

.reward-val-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.reward-val {
    font-size: 20px;
    font-weight: 800;
    color: #D1AA67;
    line-height: 1.1;
}

.reward-token {
    font-size: 11px;
    font-weight: 600;
    color: #9CA3AF;
    margin-top: 2px;
}

.task-go-btn {
    background-color: #D1AA67;
    color: #FFFFFF;
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
}

.task-go-btn:hover {
    background-color: #C09D5B;
    transform: scale(1.03);
}


/* ==========================================================================
   3. CONNECT WALLET MODAL POPUP STYLES
   ========================================================================== */

/* --- Modal Overlay & Card Container --- */
.wallet-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(255 255 255 / 40%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999999;
    padding: 0px;
    animation: fadeInModal 0.25s ease-out forwards;
}

.wallet-modal-card {
    background: #FFFFFF30;
    width: 100%;
    max-width: 750px;
    border-radius: 28px;
    padding: 30px;
    border: 2px solid #E1E1E150;
    position: relative;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

/* --- Modal Header & Floating Graphic --- */
.wallet-modal-header {
    position: relative;
    margin-bottom: 24px;
    padding-right: 140px;
}

.wallet-modal-title {
    font-size: 30px;
    font-weight: 700;
    margin: 0 0 4px 0;
    line-height: 1.25;
}

.wallet-modal-subtitle {
    font-size: 15px;
    color: #6B7280;
    margin: 0;
}

.wallet-header-graphic {
    position: absolute;
    right: 75px;
    top: -12px;
    width: 160px;
    height: auto;
    pointer-events: none;
    object-fit: contain;
    z-index: 1;
}

.wallet-modal-close-btn {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    padding: 0px;
    background: #F3F4F6;
    color: #111827;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 2;
}

.wallet-modal-close-btn:hover {
    background: #E5E7EB;
    transform: scale(1.05);
}

/* --- Tab Navigation Track & Tab Buttons --- */
.wallet-modal-tabs-wrap {
    display: inline-block;
    margin-bottom: 24px;
}

.wallet-modal-tabs {
    background: #A3A3A312;
    border-radius: 24px;
    padding: 5px;
    display: flex;
    width: 100%;
}

.wallet-tab-btn {
    flex: 1 1;
    border: none;
    background: transparent;
    border-radius: 20px;
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    color: #6B7280;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
    white-space: nowrap;
}

.wallet-tab-btn:hover {
    color: #111827;
}

.wallet-tab-btn.active {
    background: #D1AA67;
    color: #FFFFFF;
    box-shadow: 0 2px 8px rgba(209, 170, 103, 0.35);
}

/* --- Modal Body Content Container --- */
.wallet-modal-body {
    margin-bottom: 20px;
}

/* --- Tab 1: AGCX Wallet Content --- */
.wallet-option-box {
    background: #FFFFFF40;
    border: 1px solid #F3F4F6;
    border-radius: 20px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

.wallet-option-left {
    flex: 1 1;
}

.option-title {
    font-size: 17px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 4px 0;
}

.option-desc {
    font-size: 15px;
    color: #6B7280;
    margin: 0 0 10px 0;
    line-height: 1.4;
}

.option-status-link {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 15px;
}

.status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #9CA3AF;
    display: inline-block;
}

.status-text {
    color: #6B7280;
}

.gold-link {
    color: #D1AA67;
    font-weight: 600;
    text-decoration: none;
    transition: opacity 0.2s ease;
}

.gold-link:hover {
    opacity: 0.8;
    color: #D1AA67;
}

.wallet-qr-wrap {
    width: 138px;
    height: 138px;
    background: #FFFFFF;
    border: 1px solid #E5E7EB;
    border-radius: 16px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.qr-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 8px;
}

.gold-action-btn {
    background: #D1AA67;
    color: #FFFFFF;
    border: none;
    border-radius: 50px;
    padding: 15px 24px;
    font-size: 17px;
    font-weight: 700;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.2s ease, transform 0.1s ease;
}

.wallet-option-box.flex-row-center .option-desc {
    margin: 0px;
}

.gold-action-btn:hover {
    background: #C09D5B;
    transform: scale(1.02);
}

/* --- Divider Line (OR) --- */
.wallet-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 16px 0;
}

.wallet-divider::before,
.wallet-divider::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid #F0F0F0;
}

.wallet-divider span {
    padding: 0 14px;
    color: #D1D5DB;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
}

/* --- Tab 2: Other Wallet Content (MetaMask, WalletConnect, Solana) --- */
.other-wallet-section-title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 0 24px 0;
}

.other-wallet-section-title::before,
.other-wallet-section-title::after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid #F0F0F0;
}

.other-wallet-section-title span {
    padding: 0 16px;
    color: #94A3B8;
    margin-top: 2px;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.3px;
}

.other-wallet-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
}

.other-wallet-card {
    background: #FFFFFF80;
    border: 1px solid #F3F4F6;
    border-radius: 24px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    transition: all 0.2s ease;
}

.other-wallet-card:hover {
    border-color: #D1AA67;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
}

.other-wallet-icon-wrap {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
}

.other-wallet-icon-wrap img {
    width: 100%;
    object-fit: contain;
}

.other-wallet-name {
    font-size: 18px;
    font-weight: 700;
    margin: 4px 0 16px 0;
}

.outline-connect-btn {
    background: rgb(255 255 255 / 10%);
    border: 2.5px solid rgb(229 231 235 / 10%);
    border-radius: 40px;
    padding: 10px 18px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
    max-width: 100%;
}

body.light_theme .outline-connect-btn {
    background: #FFFFFF;
    border: 2.5px solid #E5E7EB;
    color: #374151;
}

.other-wallet-card:hover .outline-connect-btn {
    background: #D1AA67;
    color: #FFFFFF;
    border-color: #D1AA67;
}

/* --- Tab 3: Watch-Only Wallet Content --- */
.watch-info-banner {
    background: rgb(249 250 251 / 10%);
    border: 1px solid rgb(243 244 246 / 12%);
    border-radius: 14px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 15px 0px 20px;
}

body.light_theme .watch-info-banner {
    background: #F9FAFB;
    border: 1px solid #F3F4F6;
}

.watch-info-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #D1AA6730;
    color: #D1AA67;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.watch-info-title {
    font-size: 14px;
    font-weight: 700;
    color: #f3f3f3;
    margin: 0 0 3px 0;
}

body.light_theme .watch-info-title {
    color: #111827;
}

.watch-info-desc {
    font-size: 12.5px;
    color: #c5c5c5;
    margin: 0;
    line-height: 1.4;
}

body.light_theme .watch-info-desc {
    color: #6B7280;
}

.watch-section-title {
    font-size: 22px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 10px 0;
}

body.light_theme .watch-section-title {
    color: #111827;
}

.watch-input-group {
    display: flex;
    gap: 10px;
}

.watch-input {
    flex: 1 1;
    padding: 10px 18px;
    border-radius: 10px;
    border: 1px solid rgb(229 231 235 / 12%);
    font-size: 13px;
    color: #e0e0e0;
    outline: none;
    background: rgb(255 255 255 / 10%);
    transition: all 0.2s ease;
}

body.light_theme .watch-input {
    color: #111827;
    border: 1px solid #E5E7EB;
    background: #fff;
}

.watch-input:focus {
    border-color: #D1AA67;
}

.watch-connect-btn {
    background: #F3F4F6;
    color: #374151;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
}

.watch-connect-btn:hover {
    background: #D1AA67;
    color: #FFFFFF;
}

.watch-scan-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.watch-section-desc {
    font-size: 11.5px;
    color: #9CA3AF;
    margin: 0;
}

/* --- Security / Terms Footer Banner --- */
.wallet-modal-footer {
    background: #f9fafb12;
    border: 1px solid #f3f4f617;
    border-radius: 18px;
    padding: 14px 18px;
    margin-top: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

body.light_theme .wallet-modal-footer {
    background: #F9FAFB;
    border: 1px solid #F3F4F6;
}

.footer-terms-left {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    max-width: 80%;
    z-index: 2;
}

.terms-shield-icon {
    font-size: 20px;
    color: #9CA3AF;
    flex-shrink: 0;
    margin-top: 1px;
}

.terms-text {
    font-size: 15px;
    color: #6B7280;
    margin: 0;
    line-height: 1.45;
}

.gold-terms-link {
    color: #D1AA67;
    font-weight: 500;
    text-decoration: none;
}

.gold-terms-link:hover {
    text-decoration: underline;
    color: #D1AA67;
    opacity: 0.8;
}

.footer-security-graphic {
    position: absolute;
    right: -5px;
    bottom: -6px;
    width: 173px;
    height: auto;
    pointer-events: none;
    object-fit: contain;
    z-index: 1;
}

/* --- Modal Keyframe Animations --- */
@keyframes fadeInModal {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideUpModal {
    from {
        opacity: 0;
        transform: translateY(24px) scale(0.97);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}


/* ==========================================================================
   4. RESPONSIVE MEDIA QUERIES
   ========================================================================== */

@media (max-width: 1500px) {
    .airdrop-details-container {
        max-width: 95%;
    }

    .airdrop-detail-title {
        font-size: 48px;
    }

    .airdrops-container {
        max-width: 95%;
    }
}

@media (max-width: 1200px) {
    .airdrop-detail-title {
        font-size: 40px;
    }

    .tasks-section-title {
        font-size: 28px;
    }
}

@media (max-width: 1024px) {
    .active-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .ended-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 992px) {
    .airdrop-detail-hero-right {
        width: 100%;
        max-width: 100%;
    }

    .airdrop-detail-title {
        font-size: 32px;
    }

    .wallet-modal-card {
        max-width: 660px;
    }

    .wallet-tab-btn {
        padding: 8px 12px;
        font-size: 13px;
    }

    .wallet-header-graphic {
        right: 45px;
    }

    .wallet-modal-title {
        font-size: 24px;
    }

    .watch-section-title {
        font-size: 18px;
    }

    .terms-text {
        max-width: 85%;
        font-size: 14px;
    }

    .airdrop-detail-desc {
        font-size: 15px;
        margin: 0 0 20px 0;
    }

    .timer-val {
        border-radius: 10px;
        width: 48px;
        height: 48px;
        font-size: 16px;
    }

    .tasks-section-title {
        font-size: 24px;
    }
}

@media (max-width: 768px) {


    .airdrops-hero-title {
        font-size: 26px;
        margin-bottom: 10px;
    }

    .airdrops-hero-image {
        width: 240px;
        margin: 0 auto;
    }

    .airdrops-hero-content {
        text-align: center;
    }

    .airdrops-tabs {
        gap: 6px;
        justify-content: center;
    }

    .airdrop-tab {
        padding: 6px 18px;
        font-size: 12px;
    }

    .airdrops-section-title {
        font-size: 20px;
    }

    .airdrops-hero-desc {
        font-size: 15px;
        margin: 0 0 18px 0;
    }

    .task-card {
        align-items: flex-start;
        gap: 20px;
    }

    .task-card-right {
        justify-content: space-between;
    }

    .airdrop-details-page {
        padding: 40px 0px;
    }

    .airdrop-detail-title {
        font-size: 26px;
        margin-bottom: 10px;
    }

    .airdrops-hero {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 30px;
    }

    .airdrop-card {
        padding: 20px;
    }

    .airdrop-card-titles h3 {
        font-size: 15px;
    }

    .status-badge {
        font-size: 11px;
    }

    .airdrop-tag {
        font-size: 11px;
    }

    .airdrop-join-btn {
        padding: 9px 0;
        font-size: 12px;
    }

    .metric-group h4 {
        font-size: 14px;
    }

    .metric-group p {
        font-size: 12px;
    }

    .partner-banner-image {
        position: relative;
        margin-top: 30px;
        bottom: 0px;
    }

    .partner-banner-title {
        font-size: 22px;
    }

    .airdrop-partner-banner {
        margin-top: 50px;
    }

    .airdrop-detail-desc {
        font-size: 14px;
    }

    .airdrop-tasks-section {
        margin-top: 20px;
    }

    .active-grid {
        grid-template-columns: 1fr;
    }

    .ended-grid {
        grid-template-columns: 1fr;
    }

    .airdrop-partner-banner {
        flex-direction: column;
        padding: 30px;
        align-items: flex-start;
    }

    .partner-banner-image {
        width: 100%;
        margin-top: 20px;
    }
}

@media (max-width: 767px) {

    .airdrop-details-container {
        max-width: 100%;
    }

    .airdrop-detail-hero {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 30px;
    }

    .airdrop-details-page {
        padding: 32px 0px;
    }

    .other-wallet-icon-wrap {
        width: 70px;
        height: 70px;
    }

    .other-wallet-name {
        font-size: 15px;
    }

    .outline-connect-btn {
        padding: 8px 15px;
        font-size: 14px;
    }

    .footer-security-graphic {
        width: 130px;
    }

    .airdrop-detail-hero-right {
        width: 300px;
        margin: 0 auto;
    }

    .wallet-modal-card {
        height: 85vh;
        overflow: scroll;
        border-radius: 20px 20px 0px 0px;
    }

    .wallet-modal-title {
        font-size: 20px;
    }

    .wallet-header-graphic {
        right: 65px;
        width: 115px;
    }

    .watch-section-title {
        font-size: 15px;
    }

    .wallet-modal-overlay {
        align-items: end;
    }

    .gold-action-btn {
        padding: 9px 20px;
        font-size: 13px;
    }

    .wallet-modal-footer {
        margin-top: 18px;
    }

    .wallet-qr-wrap {
        width: 100px;
        height: 100px;
    }

}


@media (max-width: 580px) {

    .tasks-header-left {
        align-items: start;
        flex-direction: column;
        width: 100%;
    }

    .task-card {
        flex-direction: column;
        border-radius: 14px;
        padding: 20px;
    }

    .task-card-right {
        flex-direction: row;
        width: 100%;
    }

    .reward-val-wrap {
        align-items: start;
    }

    .reward-val {
        font-size: 18px;
    }

    .task-go-btn {
        padding: 6px 18px;
        font-size: 13px;
    }

    .airdrop-detail-title {
        font-size: 24px;
    }

    .tasks-section-header {
        flex-direction: column;
        align-items: end;
    }

    .tasks-section-title {
        font-size: 20px;
    }

    /* Modal Mobile Responsive */
    .wallet-modal-card {
        padding: 22px 18px;
    }

    .wallet-modal-header {
        padding-right: 80px;
    }

    .wallet-header-graphic {
        width: 90px;
        right: 40px;
        top: -10px;
    }

    .wallet-modal-title {
        font-size: 18px;
    }

    .wallet-tab-btn {
        font-size: 11px;
        padding: 6px 12px;
    }

    .wallet-modal-subtitle {
        font-size: 13px;
        max-width: 85%;
    }

    .other-wallet-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .other-wallet-card {
        padding: 12px 16px;
        gap: 12px;
    }

    .other-wallet-icon-wrap {
        margin-bottom: 0;
        width: 52px;
        height: 52px;
    }

    .other-wallet-icon-wrap img {
        width: 100%;
    }

    .option-status-link {
        align-items: start;
        font-size: 12px;
        flex-direction: column;
    }

    .option-title {
        font-size: 15px;
    }

    .terms-text {
        font-size: 13px;
    }

    .footer-security-graphic {
        bottom: 0px;
        width: 95px;
    }

    .option-desc {
        font-size: 13px;
    }

    .other-wallet-name {
        margin: 0;
    }

    .footer-terms-left {
        max-width: 75%;
    }
}

/* fix kero - Dark theme support for Airdrops pages */
html[data-theme="dark"] .airdrops-page,
html[data-theme="dark"] .airdrop-details-page,
body:not(.light_theme) .airdrops-page,
body:not(.light_theme) .airdrop-details-page {
    background-color: #0b0e14;
    color: #ffffff;
}

html[data-theme="dark"] .airdrops-hero-title,
html[data-theme="dark"] .airdrops-section-title,
html[data-theme="dark"] .airdrop-detail-title,
html[data-theme="dark"] .tasks-section-title,
html[data-theme="dark"] .airdrop-title,
html[data-theme="dark"] .reward-value,
html[data-theme="dark"] .timer-val,
html[data-theme="dark"] .task-title,
html[data-theme="dark"] .wallet-modal-title,
html[data-theme="dark"] .option-title,
html[data-theme="dark"] .other-wallet-name,
html[data-theme="dark"] .project-info-val,
body:not(.light_theme) .airdrops-hero-title,
body:not(.light_theme) .airdrops-section-title,
body:not(.light_theme) .airdrop-detail-title,
body:not(.light_theme) .tasks-section-title,
body:not(.light_theme) .airdrop-title,
body:not(.light_theme) .reward-value,
body:not(.light_theme) .timer-val,
body:not(.light_theme) .task-title,
body:not(.light_theme) .wallet-modal-title,
body:not(.light_theme) .option-title,
body:not(.light_theme) .other-wallet-name,
body:not(.light_theme) .project-info-val {
    color: #ffffff;
}

html[data-theme="dark"] .airdrops-hero-desc,
html[data-theme="dark"] .airdrop-detail-desc,
html[data-theme="dark"] .airdrop-desc,
html[data-theme="dark"] .reward-label,
html[data-theme="dark"] .timer-label,
html[data-theme="dark"] .task-desc,
html[data-theme="dark"] .wallet-modal-subtitle,
html[data-theme="dark"] .option-desc,
html[data-theme="dark"] .terms-text,
html[data-theme="dark"] .project-info-label,
html[data-theme="dark"] .wallet-tab-btn,
body:not(.light_theme) .airdrops-hero-desc,
body:not(.light_theme) .airdrop-detail-desc,
body:not(.light_theme) .airdrop-desc,
body:not(.light_theme) .reward-label,
body:not(.light_theme) .timer-label,
body:not(.light_theme) .task-desc,
body:not(.light_theme) .wallet-modal-subtitle,
body:not(.light_theme) .option-desc,
body:not(.light_theme) .terms-text,
body:not(.light_theme) .project-info-label,
body:not(.light_theme) .wallet-tab-btn {
    color: #a0aab5;
}

html[data-theme="dark"] .airdrop-card,
html[data-theme="dark"] .task-card,
html[data-theme="dark"] .wallet-option-box,
html[data-theme="dark"] .connect-option,
html[data-theme="dark"] .other-wallet-card,
body:not(.light_theme) .airdrop-card,
body:not(.light_theme) .task-card,
body:not(.light_theme) .wallet-option-box,
body:not(.light_theme) .connect-option,
body:not(.light_theme) .other-wallet-card {
    background-color: #181a20;
    border-color: #2b3139;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

html[data-theme="dark"] .wallet-modal-card,
body:not(.light_theme) .wallet-modal-card {
    background-color: #181a2020;
    border-color: #2b3139a6;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

html[data-theme="dark"] .airdrop-tab,
body:not(.light_theme) .airdrop-tab {
    background-color: #2b3139;
    color: #a0aab5;
}

html[data-theme="dark"] .airdrop-tab.active,
html[data-theme="dark"] .wallet-tab-btn.active,
body:not(.light_theme) .airdrop-tab.active,
body:not(.light_theme) .wallet-tab-btn.active {
    background-color: #D3B06C;
    color: #ffffff;
}

html[data-theme="dark"] .airdrop-tab:hover,
body:not(.light_theme) .airdrop-tab:hover {
    background-color: #3b424a;
}

html[data-theme="dark"] .wallet-tab-btn:hover,
body:not(.light_theme) .wallet-tab-btn:hover {
    color: #ffffff;
}

html[data-theme="dark"] .tag.tag-upcoming,
html[data-theme="dark"] .tag.tag-ended,
body:not(.light_theme) .tag.tag-upcoming,
body:not(.light_theme) .tag.tag-ended {
    background-color: #2b3139;
    color: #a0aab5;
}

html[data-theme="dark"] .timer-val,
html[data-theme="dark"] .footer-terms,
body:not(.light_theme) .timer-val,
body:not(.light_theme) .footer-terms {
    background-color: #0d1219;
    border-color: #2b3139;
}

html[data-theme="dark"] .wallet-modal-close-btn,
body:not(.light_theme) .wallet-modal-close-btn {
    background-color: #2b3139;
    color: #a0aab5;
}

html[data-theme="dark"] .wallet-modal-close-btn:hover,
body:not(.light_theme) .wallet-modal-close-btn:hover {
    background-color: #3b424a;
    color: #ffffff;
}

html[data-theme="dark"] .wallet-modal-overlay,
body:not(.light_theme) .wallet-modal-overlay {
    background-color: rgb(11 14 20 / 70%);
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Airdrops/airdrops.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,mCAAmC;AACnC;IACI,iEAAiE;IACjE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;;AAE/E;IACI,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;GAEG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0CAA0C;IAC1C,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;;AAGA;;+EAE+E;;AAE/E,2CAA2C;AAC3C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,2BAA2B;IAC3B,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,gFAAgF;IAChF,gBAAgB;IAChB,oEAAoE;AACxE;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,+CAA+C;AACnD;;AAEA,yCAAyC;AACzC;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qDAAqD;AACzD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,0EAA0E;AAC1E;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,SAAO;IACP,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,6CAA6C;AAC7C;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,aAAa;IACb,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;;AAEA,2CAA2C;AAC3C;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;AACd;;AAEA,sCAAsC;AACtC;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;;IAEA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;;AAGA;;+EAE+E;;AAE/E;IACI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;;IAGI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,QAAQ;QACR,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;AAEJ;;;AAGA;;IAEI;QACI,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA,4BAA4B;IAC5B;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,qDAAqD;AACrD;;;;IAII,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;IAsBI,cAAc;AAClB;;AAEA;;;;;;;;;;IAUI,yBAAyB;IACzB,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;;IAEI,2BAA2B;IAC3B,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;;IAII,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;AACzC","sourcesContent":["/* ==========================================================================\n   1. AIRDROPS MAIN PAGE STYLES (/airdrops)\n   ========================================================================== */\n\n.airdrops-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 40px 0 80px 0;\n}\n\n.airdrops-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n/* --- Hero Section --- */\n.airdrops-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 50px;\n    gap: 40px;\n}\n\n.airdrops-hero-content {\n    flex: 1;\n    max-width: 600px;\n}\n\nbody.light_theme .participants-text strong {\n    color: #000000;\n}\n\n.airdrop-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #D1AA67;\n    margin-bottom: 12px;\n}\n\n.airdrop-badge-icon {\n    font-size: 14px;\n}\n\n.airdrops-hero-title {\n    font-size: 40px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 16px 0;\n    line-height: 1.2;\n}\n\n.airdrops-hero-desc {\n    font-size: 16px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 24px 0;\n}\n\n.airdrops-tabs {\n    display: flex;\n    gap: 10px;\n}\n\n.airdrop-tab {\n    padding: 8px 20px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #6B7280;\n    background-color: #E5E7EB;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.airdrop-tab.active {\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    font-weight: 600;\n}\n\n.airdrops-hero-image {\n    width: 340px;\n    max-width: 100%;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.airdrops-hero-image img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n/* --- Section Headers --- */\n.airdrops-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.airdrops-section-title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.airdrops-section-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #111827;\n    margin: 0;\n}\n\n.airdrops-count-badge {\n    background-color: #F3F4F6;\n    color: #6B7280;\n    font-size: 12px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 12px;\n}\n\n.airdrops-sort-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 14px;\n    border-radius: 8px;\n    background-color: #E6E6E6;\n    border: 1px solid #E5E7EB;\n    font-size: 14px;\n    font-weight: 600;\n    color: #374151;\n}\n\n.airdrops-view-more {\n    font-size: 14px;\n    font-weight: 600;\n    color: #D1AA67;\n    text-decoration: none;\n}\n\n/* --- Active Grid Section --- */\n.active-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-bottom: 60px;\n}\n\n.airdrop-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F0F0F0;\n    border-radius: 18px;\n    padding: 24px;\n    box-shadow: 0 1px 8px rgb(0 0 0 / 9%);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.airdrop-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n}\n\n.airdrop-card-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 16px;\n}\n\n.airdrop-card-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.airdrop-card-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #FFFFFF;\n    font-size: 16px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.avatar-purple {\n    background-color: #6366F1;\n}\n\n.avatar-gold {\n    background-color: #D97706;\n}\n\n.avatar-teal {\n    background-color: #0D9488;\n}\n\n.avatar-red {\n    background-color: #EF4444;\n}\n\n.avatar-cyan {\n    background-color: #06B6D4;\n}\n\n.avatar-grey {\n    background-color: #6B7280;\n}\n\n.avatar-pink {\n    background-color: #EC4899;\n}\n\n.airdrop-card-titles h3 {\n    font-size: 17px;\n    font-weight: 700;\n    color: #101828;\n    margin: 0 0 2px 0;\n    line-height: 1.3;\n}\n\n.airdrop-card-titles p {\n    font-size: 14px;\n    color: #9CA3AF;\n    margin: 0;\n}\n\n.status-badge {\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.status-live {\n    background-color: #DCFCE7;\n    color: #059669;\n}\n\n.status-ended {\n    background-color: #F3F4F6;\n    color: #9CA3AF;\n}\n\n/* Tags */\n.airdrop-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 20px;\n}\n\n.airdrop-tag {\n    padding: 3px 8px;\n    border-radius: 4px;\n    color: #6A7282;\n    font-size: 13px;\n    background-color: #F9FAFB26;\n    font-weight: 600;\n}\n\nbody.light_theme .airdrop-tag {\n    background-color: #F9FAFB;\n}\n\n.tag-sol {\n    background-color: #f3e8ff26;\n    color: #9333EA;\n}\n\nbody.light_theme .tag-sol {\n    background-color: #F3E8FF;\n}\n\n.tag-eth {\n    background-color: #E0E7FF26;\n    color: #4F46E5;\n}\n\nbody.light_theme .tag-eth {\n    background-color: #E0E7FF;\n}\n\n.tag-arb {\n    background-color: #E0F2FE20;\n    color: #0284C7;\n}\n\nbody.light_theme .tag-arb {\n    background-color: #E0F2FE;\n}\n\n.tag-token {\n    background-color: #DCFCE7;\n    color: #16A34A;\n}\n\n.tag-free {\n    background-color: #F3F4F620;\n    color: #4B5563;\n}\n\nbody.light_theme .tag-free {\n    background-color: #F3F4F6;\n}\n\n.tag-bnb {\n    background-color: #FEF9C320;\n    color: #CA8A04;\n}\n\nbody.light_theme .tag-bnb {\n    background-color: #FEF9C3;\n}\n\n.tag-carnival {\n    background-color: #FFEDD520;\n    color: #EA580C;\n}\n\nbody.light_theme .tag-carnival {\n    background-color: #FFEDD5;\n}\n\n.tag-stc {\n    background-color: #FCE7F320;\n    color: #E11D48;\n}\n\nbody.light_theme .tag-stc {\n    background-color: #FCE7F3;\n}\n\n.tag-nft {\n    background-color: #ECE9FE;\n    color: #7C3AED;\n}\n\n.tag-mint {\n    background-color: #CCFBF120;\n    color: #0D9488;\n}\n\nbody.light_theme .tag-mint {\n    background-color: #CCFBF1;\n}\n\n.tag-zeta {\n    background-color: #E0F2FE20;\n    color: #0369A1;\n}\n\nbody.light_theme .tag-zeta {\n    background-color: #E0F2FE;\n}\n\n.tag-layer1 {\n    background-color: #F1F5F920;\n    color: #475569;\n}\n\nbody.light_theme .tag-layer1 {\n    background-color: #F1F5F9;\n}\n\n/* Metrics */\n.airdrop-metrics {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-bottom: 20px;\n    background-color: #fafafa08;\n    padding: 12px;\n    border-radius: 10px;\n}\n\nbody.light_theme .airdrop-metrics {\n    background-color: #FAFAFA;\n}\n\n.metric-group p {\n    font-size: 14px;\n    color: #9CA3AF;\n    margin: 0 0 2px 0;\n}\n\n.metric-group h4 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #f3f3f3;\n    margin: 3px 0 2px 0;\n}\n\nbody.light_theme .metric-group h4 {\n    color: #101828;\n}\n\n.metric-group span {\n    font-size: 14px;\n    color: #d4d4d4;\n}\n\nbody.light_theme .metric-group span {\n    color: #6B7280;\n}\n\n.participants-count {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 16px;\n    font-weight: 700;\n    color: #d1d1d1;\n    justify-content: right;\n}\n\nbody.light_theme .participants-count {\n    color: #374151;\n}\n\n.participants-count i {\n    font-size: 13px;\n    color: #9CA3AF;\n}\n\n/* Action Button */\n.airdrop-join-btn {\n    width: 100%;\n    padding: 11px 0;\n    border-radius: 20px;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 500;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: background-color 0.2s ease;\n}\n\n.airdrop-join-btn:hover {\n    background-color: #C09D5B;\n}\n\n/* --- Ended Grid Section --- */\n.ended-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    margin-bottom: 60px;\n}\n\n.ended-card {\n    background-color: #181a20;\n    border: 1px solid #f3f4f617;\n    border-radius: 14px;\n    padding: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 8px rgb(0 0 0 / 12%);\n}\n\nbody.light_theme .ended-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n}\n\n.ended-card-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.ended-avatar {\n    width: 34px;\n    height: 34px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.ended-info h4 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #e9e9e9;\n    margin: 0 0 2px 0;\n    line-height: 1.3;\n}\n\nbody.light_theme .ended-info h4 {\n    color: #111827;\n}\n\n.ended-info p {\n    font-size: 14px;\n    color: #9CA3AF;\n    margin: 0;\n}\n\n/* --- Partner Banner Section --- */\n.airdrop-partner-banner {\n    background: linear-gradient(135deg, #ebecee0f 0%, #e2e4e712 100%);\n    border-radius: 20px;\n    padding: 40px 50px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    margin-top: 140px;\n}\n\nbody.light_theme .airdrop-partner-banner {\n    background: linear-gradient(135deg, #EBECEE 0%, #E2E4E7 100%);\n}\n\n.partner-banner-content {\n    max-width: 500px;\n    z-index: 2;\n}\n\n.partner-banner-subtitle {\n    font-size: 14px;\n    font-weight: 700;\n    color: #d4d4d4;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\nbody.light_theme .partner-banner-subtitle {\n    color: #303030;\n}\n\n.partner-banner-title {\n    font-size: 28px;\n    font-weight: 800;\n    color: #fafafa;\n    margin: 0 0 12px 0;\n    line-height: 1.3;\n}\n\nbody.light_theme .partner-banner-title {\n    color: #111827;\n}\n\n.partner-banner-desc {\n    font-size: 16px;\n    color: #b4b4b4;\n    margin: 0;\n}\n\nbody.light_theme .partner-banner-desc {\n    color: #4B5563;\n}\n\n.partner-banner-image {\n    width: 380px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n    position: absolute;\n    right: 30px;\n    bottom: 30px;\n}\n\n.partner-banner-image img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   2. AIRDROP DETAILS PAGE STYLES (/airdrop-detail)\n   ========================================================================== */\n\n.airdrop-details-page {\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 80px 0px;\n    min-height: 100vh;\n}\n\n.airdrop-details-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n}\n\n/* --- Breadcrumb --- */\n.airdrop-breadcrumb {\n    font-size: 13px;\n    color: #9CA3AF;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.airdrop-breadcrumb .breadcrumb-link {\n    color: #D1AA67;\n    text-decoration: none;\n    transition: color 0.2s ease;\n}\n\n/* .airdrop-breadcrumb .breadcrumb-link:hover {\n    color: #111827;\n} */\n\n.airdrop-breadcrumb .breadcrumb-sep {\n    color: #D1D5DB;\n}\n\n.airdrop-breadcrumb .breadcrumb-current {\n    color: #6B7280;\n    font-weight: 500;\n}\n\n/* --- Hero Section --- */\n.airdrop-detail-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 60px;\n    gap: 40px;\n}\n\n.airdrop-detail-hero-left {\n    flex: 1;\n    max-width: 650px;\n}\n\n.airdrop-detail-title {\n    font-size: 60px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.15;\n    margin: 0 0 16px 0;\n}\n\n.gold-gradient-text {\n    color: #D1AA67;\n    font-weight: 800;\n}\n\n.airdrop-detail-desc {\n    font-size: 16px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 32px 0;\n}\n\n/* --- Countdown Timer --- */\n.airdrop-countdown-wrap {\n    margin-bottom: 24px;\n}\n\n.countdown-label {\n    display: block;\n    font-size: 13px;\n    color: #6B7280;\n    margin-bottom: 10px;\n    font-weight: 500;\n}\n\n.countdown-boxes {\n    display: flex;\n    gap: 12px;\n}\n\n.timer-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.timer-val {\n    background-color: #F5F5F5;\n    border: 1px solid #D1D1D1;\n    border-radius: 14px;\n    width: 64px;\n    height: 64px;\n    box-shadow: inset 0 0px 10px rgba(0, 0, 0, 0.2);\n    font-size: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 800;\n    color: #D1AA67;\n    line-height: 1.1;\n}\n\n.timer-unit {\n    font-size: 14px;\n    color: #9CA3AF;\n    font-weight: 500;\n    margin-top: 4px;\n}\n\n/* --- Meta Row: Participants & Rules --- */\n.airdrop-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    font-size: 14px;\n}\n\n.participants-text {\n    color: #6B7280;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.participants-text strong {\n    color: #f3f3f3;\n}\n\nbody.light_light .participants-text strong {\n    color: #111827;\n}\n\n.event-rules-link {\n    color: #D1AA67;\n    font-weight: 600;\n    text-decoration: none;\n    transition: opacity 0.2s ease;\n}\n\n.event-rules-link:hover {\n    opacity: 0.8;\n    color: #D1AA67;\n}\n\n/* --- Hero Right Image --- */\n.airdrop-detail-hero-right {\n    flex: 1 1;\n    max-width: 610px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.airdrop-detail-img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n/* --- Web3 Newbie Reward Tasks Section --- */\n.airdrop-tasks-section {\n    margin-top: 100px;\n}\n\n.tasks-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.tasks-header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.tasks-section-title {\n    font-size: 34px;\n    font-weight: 600;\n    color: #101828;\n    margin: 0;\n}\n\n.badge-ongoing {\n    background-color: #DCFCE7;\n    color: #059669;\n    font-size: 13px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 12px;\n}\n\n.view-rules-link {\n    font-size: 13.5px;\n    color: #D1AA67;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.view-rules-link:hover {\n    color: #c59d57;\n}\n\n/* --- Tasks Cards List --- */\n.tasks-list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.task-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 16px;\n    padding: 28px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.task-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);\n}\n\n.task-card-left {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n}\n\n.task-num-badge {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: #D1AA6730;\n    color: #D1AA67;\n    font-size: 16px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.task-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.task-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 6px 0;\n}\n\n.task-desc {\n    font-size: 13.5px;\n    color: #9CA3AF;\n    margin: 0 0 10px 0;\n    line-height: 1.4;\n    max-width: 600px;\n}\n\n.task-progress {\n    font-size: 12px;\n    font-weight: 600;\n    color: #6B7280;\n}\n\n.task-card-right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-direction: column;\n}\n\n.reward-val-wrap {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.reward-val {\n    font-size: 20px;\n    font-weight: 800;\n    color: #D1AA67;\n    line-height: 1.1;\n}\n\n.reward-token {\n    font-size: 11px;\n    font-weight: 600;\n    color: #9CA3AF;\n    margin-top: 2px;\n}\n\n.task-go-btn {\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 20px;\n    padding: 8px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.task-go-btn:hover {\n    background-color: #C09D5B;\n    transform: scale(1.03);\n}\n\n\n/* ==========================================================================\n   3. CONNECT WALLET MODAL POPUP STYLES\n   ========================================================================== */\n\n/* --- Modal Overlay & Card Container --- */\n.wallet-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgb(255 255 255 / 40%);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999999;\n    padding: 0px;\n    animation: fadeInModal 0.25s ease-out forwards;\n}\n\n.wallet-modal-card {\n    background: #FFFFFF30;\n    width: 100%;\n    max-width: 750px;\n    border-radius: 28px;\n    padding: 30px;\n    border: 2px solid #E1E1E150;\n    position: relative;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n    animation: slideUpModal 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n/* --- Modal Header & Floating Graphic --- */\n.wallet-modal-header {\n    position: relative;\n    margin-bottom: 24px;\n    padding-right: 140px;\n}\n\n.wallet-modal-title {\n    font-size: 30px;\n    font-weight: 700;\n    margin: 0 0 4px 0;\n    line-height: 1.25;\n}\n\n.wallet-modal-subtitle {\n    font-size: 15px;\n    color: #6B7280;\n    margin: 0;\n}\n\n.wallet-header-graphic {\n    position: absolute;\n    right: 75px;\n    top: -12px;\n    width: 160px;\n    height: auto;\n    pointer-events: none;\n    object-fit: contain;\n    z-index: 1;\n}\n\n.wallet-modal-close-btn {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    padding: 0px;\n    background: #F3F4F6;\n    color: #111827;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    z-index: 2;\n}\n\n.wallet-modal-close-btn:hover {\n    background: #E5E7EB;\n    transform: scale(1.05);\n}\n\n/* --- Tab Navigation Track & Tab Buttons --- */\n.wallet-modal-tabs-wrap {\n    display: inline-block;\n    margin-bottom: 24px;\n}\n\n.wallet-modal-tabs {\n    background: #A3A3A312;\n    border-radius: 24px;\n    padding: 5px;\n    display: flex;\n    width: 100%;\n}\n\n.wallet-tab-btn {\n    flex: 1 1;\n    border: none;\n    background: transparent;\n    border-radius: 20px;\n    padding: 10px 22px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #6B7280;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: center;\n    white-space: nowrap;\n}\n\n.wallet-tab-btn:hover {\n    color: #111827;\n}\n\n.wallet-tab-btn.active {\n    background: #D1AA67;\n    color: #FFFFFF;\n    box-shadow: 0 2px 8px rgba(209, 170, 103, 0.35);\n}\n\n/* --- Modal Body Content Container --- */\n.wallet-modal-body {\n    margin-bottom: 20px;\n}\n\n/* --- Tab 1: AGCX Wallet Content --- */\n.wallet-option-box {\n    background: #FFFFFF40;\n    border: 1px solid #F3F4F6;\n    border-radius: 20px;\n    padding: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n}\n\n.wallet-option-left {\n    flex: 1;\n}\n\n.option-title {\n    font-size: 17px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 4px 0;\n}\n\n.option-desc {\n    font-size: 15px;\n    color: #6B7280;\n    margin: 0 0 10px 0;\n    line-height: 1.4;\n}\n\n.option-status-link {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 15px;\n}\n\n.status-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #9CA3AF;\n    display: inline-block;\n}\n\n.status-text {\n    color: #6B7280;\n}\n\n.gold-link {\n    color: #D1AA67;\n    font-weight: 600;\n    text-decoration: none;\n    transition: opacity 0.2s ease;\n}\n\n.gold-link:hover {\n    opacity: 0.8;\n    color: #D1AA67;\n}\n\n.wallet-qr-wrap {\n    width: 138px;\n    height: 138px;\n    background: #FFFFFF;\n    border: 1px solid #E5E7EB;\n    border-radius: 16px;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.qr-img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.gold-action-btn {\n    background: #D1AA67;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 50px;\n    padding: 15px 24px;\n    font-size: 17px;\n    font-weight: 700;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background 0.2s ease, transform 0.1s ease;\n}\n\n.wallet-option-box.flex-row-center .option-desc {\n    margin: 0px;\n}\n\n.gold-action-btn:hover {\n    background: #C09D5B;\n    transform: scale(1.02);\n}\n\n/* --- Divider Line (OR) --- */\n.wallet-divider {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 16px 0;\n}\n\n.wallet-divider::before,\n.wallet-divider::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid #F0F0F0;\n}\n\n.wallet-divider span {\n    padding: 0 14px;\n    color: #D1D5DB;\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n}\n\n/* --- Tab 2: Other Wallet Content (MetaMask, WalletConnect, Solana) --- */\n.other-wallet-section-title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin: 0 0 24px 0;\n}\n\n.other-wallet-section-title::before,\n.other-wallet-section-title::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid #F0F0F0;\n}\n\n.other-wallet-section-title span {\n    padding: 0 16px;\n    color: #94A3B8;\n    margin-top: 2px;\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0.3px;\n}\n\n.other-wallet-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n}\n\n.other-wallet-card {\n    background: #FFFFFF80;\n    border: 1px solid #F3F4F6;\n    border-radius: 24px;\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    transition: all 0.2s ease;\n}\n\n.other-wallet-card:hover {\n    border-color: #D1AA67;\n    transform: translateY(-2px);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);\n}\n\n.other-wallet-icon-wrap {\n    width: 90px;\n    height: 90px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 14px;\n}\n\n.other-wallet-icon-wrap img {\n    width: 100%;\n    object-fit: contain;\n}\n\n.other-wallet-name {\n    font-size: 18px;\n    font-weight: 700;\n    margin: 4px 0 16px 0;\n}\n\n.outline-connect-btn {\n    background: rgb(255 255 255 / 10%);\n    border: 2.5px solid rgb(229 231 235 / 10%);\n    border-radius: 40px;\n    padding: 10px 18px;\n    font-size: 16px;\n    font-weight: 600;\n    color: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    width: 100%;\n    max-width: 100%;\n}\n\nbody.light_theme .outline-connect-btn {\n    background: #FFFFFF;\n    border: 2.5px solid #E5E7EB;\n    color: #374151;\n}\n\n.other-wallet-card:hover .outline-connect-btn {\n    background: #D1AA67;\n    color: #FFFFFF;\n    border-color: #D1AA67;\n}\n\n/* --- Tab 3: Watch-Only Wallet Content --- */\n.watch-info-banner {\n    background: rgb(249 250 251 / 10%);\n    border: 1px solid rgb(243 244 246 / 12%);\n    border-radius: 14px;\n    padding: 14px 16px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    margin: 15px 0px 20px;\n}\n\nbody.light_theme .watch-info-banner {\n    background: #F9FAFB;\n    border: 1px solid #F3F4F6;\n}\n\n.watch-info-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: #D1AA6730;\n    color: #D1AA67;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.watch-info-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #f3f3f3;\n    margin: 0 0 3px 0;\n}\n\nbody.light_theme .watch-info-title {\n    color: #111827;\n}\n\n.watch-info-desc {\n    font-size: 12.5px;\n    color: #c5c5c5;\n    margin: 0;\n    line-height: 1.4;\n}\n\nbody.light_theme .watch-info-desc {\n    color: #6B7280;\n}\n\n.watch-section-title {\n    font-size: 22px;\n    font-weight: 600;\n    color: #fff;\n    margin: 0 0 10px 0;\n}\n\nbody.light_theme .watch-section-title {\n    color: #111827;\n}\n\n.watch-input-group {\n    display: flex;\n    gap: 10px;\n}\n\n.watch-input {\n    flex: 1 1;\n    padding: 10px 18px;\n    border-radius: 10px;\n    border: 1px solid rgb(229 231 235 / 12%);\n    font-size: 13px;\n    color: #e0e0e0;\n    outline: none;\n    background: rgb(255 255 255 / 10%);\n    transition: all 0.2s ease;\n}\n\nbody.light_theme .watch-input {\n    color: #111827;\n    border: 1px solid #E5E7EB;\n    background: #fff;\n}\n\n.watch-input:focus {\n    border-color: #D1AA67;\n}\n\n.watch-connect-btn {\n    background: #F3F4F6;\n    color: #374151;\n    border: none;\n    border-radius: 10px;\n    padding: 10px 20px;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.watch-connect-btn:hover {\n    background: #D1AA67;\n    color: #FFFFFF;\n}\n\n.watch-scan-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.watch-section-desc {\n    font-size: 11.5px;\n    color: #9CA3AF;\n    margin: 0;\n}\n\n/* --- Security / Terms Footer Banner --- */\n.wallet-modal-footer {\n    background: #f9fafb12;\n    border: 1px solid #f3f4f617;\n    border-radius: 18px;\n    padding: 14px 18px;\n    margin-top: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n}\n\nbody.light_theme .wallet-modal-footer {\n    background: #F9FAFB;\n    border: 1px solid #F3F4F6;\n}\n\n.footer-terms-left {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    max-width: 80%;\n    z-index: 2;\n}\n\n.terms-shield-icon {\n    font-size: 20px;\n    color: #9CA3AF;\n    flex-shrink: 0;\n    margin-top: 1px;\n}\n\n.terms-text {\n    font-size: 15px;\n    color: #6B7280;\n    margin: 0;\n    line-height: 1.45;\n}\n\n.gold-terms-link {\n    color: #D1AA67;\n    font-weight: 500;\n    text-decoration: none;\n}\n\n.gold-terms-link:hover {\n    text-decoration: underline;\n    color: #D1AA67;\n    opacity: 0.8;\n}\n\n.footer-security-graphic {\n    position: absolute;\n    right: -5px;\n    bottom: -6px;\n    width: 173px;\n    height: auto;\n    pointer-events: none;\n    object-fit: contain;\n    z-index: 1;\n}\n\n/* --- Modal Keyframe Animations --- */\n@keyframes fadeInModal {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideUpModal {\n    from {\n        opacity: 0;\n        transform: translateY(24px) scale(0.97);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n\n/* ==========================================================================\n   4. RESPONSIVE MEDIA QUERIES\n   ========================================================================== */\n\n@media (max-width: 1500px) {\n    .airdrop-details-container {\n        max-width: 95%;\n    }\n\n    .airdrop-detail-title {\n        font-size: 48px;\n    }\n\n    .airdrops-container {\n        max-width: 95%;\n    }\n}\n\n@media (max-width: 1200px) {\n    .airdrop-detail-title {\n        font-size: 40px;\n    }\n\n    .tasks-section-title {\n        font-size: 28px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .active-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .ended-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 992px) {\n    .airdrop-detail-hero-right {\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .airdrop-detail-title {\n        font-size: 32px;\n    }\n\n    .wallet-modal-card {\n        max-width: 660px;\n    }\n\n    .wallet-tab-btn {\n        padding: 8px 12px;\n        font-size: 13px;\n    }\n\n    .wallet-header-graphic {\n        right: 45px;\n    }\n\n    .wallet-modal-title {\n        font-size: 24px;\n    }\n\n    .watch-section-title {\n        font-size: 18px;\n    }\n\n    .terms-text {\n        max-width: 85%;\n        font-size: 14px;\n    }\n\n    .airdrop-detail-desc {\n        font-size: 15px;\n        margin: 0 0 20px 0;\n    }\n\n    .timer-val {\n        border-radius: 10px;\n        width: 48px;\n        height: 48px;\n        font-size: 16px;\n    }\n\n    .tasks-section-title {\n        font-size: 24px;\n    }\n}\n\n@media (max-width: 768px) {\n\n\n    .airdrops-hero-title {\n        font-size: 26px;\n        margin-bottom: 10px;\n    }\n\n    .airdrops-hero-image {\n        width: 240px;\n        margin: 0 auto;\n    }\n\n    .airdrops-hero-content {\n        text-align: center;\n    }\n\n    .airdrops-tabs {\n        gap: 6px;\n        justify-content: center;\n    }\n\n    .airdrop-tab {\n        padding: 6px 18px;\n        font-size: 12px;\n    }\n\n    .airdrops-section-title {\n        font-size: 20px;\n    }\n\n    .airdrops-hero-desc {\n        font-size: 15px;\n        margin: 0 0 18px 0;\n    }\n\n    .task-card {\n        align-items: flex-start;\n        gap: 20px;\n    }\n\n    .task-card-right {\n        justify-content: space-between;\n    }\n\n    .airdrop-details-page {\n        padding: 40px 0px;\n    }\n\n    .airdrop-detail-title {\n        font-size: 26px;\n        margin-bottom: 10px;\n    }\n\n    .airdrops-hero {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 30px;\n    }\n\n    .airdrop-card {\n        padding: 20px;\n    }\n\n    .airdrop-card-titles h3 {\n        font-size: 15px;\n    }\n\n    .status-badge {\n        font-size: 11px;\n    }\n\n    .airdrop-tag {\n        font-size: 11px;\n    }\n\n    .airdrop-join-btn {\n        padding: 9px 0;\n        font-size: 12px;\n    }\n\n    .metric-group h4 {\n        font-size: 14px;\n    }\n\n    .metric-group p {\n        font-size: 12px;\n    }\n\n    .partner-banner-image {\n        position: relative;\n        margin-top: 30px;\n        bottom: 0px;\n    }\n\n    .partner-banner-title {\n        font-size: 22px;\n    }\n\n    .airdrop-partner-banner {\n        margin-top: 50px;\n    }\n\n    .airdrop-detail-desc {\n        font-size: 14px;\n    }\n\n    .airdrop-tasks-section {\n        margin-top: 20px;\n    }\n\n    .active-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .ended-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .airdrop-partner-banner {\n        flex-direction: column;\n        padding: 30px;\n        align-items: flex-start;\n    }\n\n    .partner-banner-image {\n        width: 100%;\n        margin-top: 20px;\n    }\n}\n\n@media (max-width: 767px) {\n\n    .airdrop-details-container {\n        max-width: 100%;\n    }\n\n    .airdrop-detail-hero {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 30px;\n    }\n\n    .airdrop-details-page {\n        padding: 32px 0px;\n    }\n\n    .other-wallet-icon-wrap {\n        width: 70px;\n        height: 70px;\n    }\n\n    .other-wallet-name {\n        font-size: 15px;\n    }\n\n    .outline-connect-btn {\n        padding: 8px 15px;\n        font-size: 14px;\n    }\n\n    .footer-security-graphic {\n        width: 130px;\n    }\n\n    .airdrop-detail-hero-right {\n        width: 300px;\n        margin: 0 auto;\n    }\n\n    .wallet-modal-card {\n        height: 85vh;\n        overflow: scroll;\n        border-radius: 20px 20px 0px 0px;\n    }\n\n    .wallet-modal-title {\n        font-size: 20px;\n    }\n\n    .wallet-header-graphic {\n        right: 65px;\n        width: 115px;\n    }\n\n    .watch-section-title {\n        font-size: 15px;\n    }\n\n    .wallet-modal-overlay {\n        align-items: end;\n    }\n\n    .gold-action-btn {\n        padding: 9px 20px;\n        font-size: 13px;\n    }\n\n    .wallet-modal-footer {\n        margin-top: 18px;\n    }\n\n    .wallet-qr-wrap {\n        width: 100px;\n        height: 100px;\n    }\n\n}\n\n\n@media (max-width: 580px) {\n\n    .tasks-header-left {\n        align-items: start;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .task-card {\n        flex-direction: column;\n        border-radius: 14px;\n        padding: 20px;\n    }\n\n    .task-card-right {\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .reward-val-wrap {\n        align-items: start;\n    }\n\n    .reward-val {\n        font-size: 18px;\n    }\n\n    .task-go-btn {\n        padding: 6px 18px;\n        font-size: 13px;\n    }\n\n    .airdrop-detail-title {\n        font-size: 24px;\n    }\n\n    .tasks-section-header {\n        flex-direction: column;\n        align-items: end;\n    }\n\n    .tasks-section-title {\n        font-size: 20px;\n    }\n\n    /* Modal Mobile Responsive */\n    .wallet-modal-card {\n        padding: 22px 18px;\n    }\n\n    .wallet-modal-header {\n        padding-right: 80px;\n    }\n\n    .wallet-header-graphic {\n        width: 90px;\n        right: 40px;\n        top: -10px;\n    }\n\n    .wallet-modal-title {\n        font-size: 18px;\n    }\n\n    .wallet-tab-btn {\n        font-size: 11px;\n        padding: 6px 12px;\n    }\n\n    .wallet-modal-subtitle {\n        font-size: 13px;\n        max-width: 85%;\n    }\n\n    .other-wallet-grid {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n\n    .other-wallet-card {\n        padding: 12px 16px;\n        gap: 12px;\n    }\n\n    .other-wallet-icon-wrap {\n        margin-bottom: 0;\n        width: 52px;\n        height: 52px;\n    }\n\n    .other-wallet-icon-wrap img {\n        width: 100%;\n    }\n\n    .option-status-link {\n        align-items: start;\n        font-size: 12px;\n        flex-direction: column;\n    }\n\n    .option-title {\n        font-size: 15px;\n    }\n\n    .terms-text {\n        font-size: 13px;\n    }\n\n    .footer-security-graphic {\n        bottom: 0px;\n        width: 95px;\n    }\n\n    .option-desc {\n        font-size: 13px;\n    }\n\n    .other-wallet-name {\n        margin: 0;\n    }\n\n    .footer-terms-left {\n        max-width: 75%;\n    }\n}\n\n/* fix kero - Dark theme support for Airdrops pages */\nhtml[data-theme=\"dark\"] .airdrops-page,\nhtml[data-theme=\"dark\"] .airdrop-details-page,\nbody:not(.light_theme) .airdrops-page,\nbody:not(.light_theme) .airdrop-details-page {\n    background-color: #0b0e14;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .airdrops-hero-title,\nhtml[data-theme=\"dark\"] .airdrops-section-title,\nhtml[data-theme=\"dark\"] .airdrop-detail-title,\nhtml[data-theme=\"dark\"] .tasks-section-title,\nhtml[data-theme=\"dark\"] .airdrop-title,\nhtml[data-theme=\"dark\"] .reward-value,\nhtml[data-theme=\"dark\"] .timer-val,\nhtml[data-theme=\"dark\"] .task-title,\nhtml[data-theme=\"dark\"] .wallet-modal-title,\nhtml[data-theme=\"dark\"] .option-title,\nhtml[data-theme=\"dark\"] .other-wallet-name,\nhtml[data-theme=\"dark\"] .project-info-val,\nbody:not(.light_theme) .airdrops-hero-title,\nbody:not(.light_theme) .airdrops-section-title,\nbody:not(.light_theme) .airdrop-detail-title,\nbody:not(.light_theme) .tasks-section-title,\nbody:not(.light_theme) .airdrop-title,\nbody:not(.light_theme) .reward-value,\nbody:not(.light_theme) .timer-val,\nbody:not(.light_theme) .task-title,\nbody:not(.light_theme) .wallet-modal-title,\nbody:not(.light_theme) .option-title,\nbody:not(.light_theme) .other-wallet-name,\nbody:not(.light_theme) .project-info-val {\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .airdrops-hero-desc,\nhtml[data-theme=\"dark\"] .airdrop-detail-desc,\nhtml[data-theme=\"dark\"] .airdrop-desc,\nhtml[data-theme=\"dark\"] .reward-label,\nhtml[data-theme=\"dark\"] .timer-label,\nhtml[data-theme=\"dark\"] .task-desc,\nhtml[data-theme=\"dark\"] .wallet-modal-subtitle,\nhtml[data-theme=\"dark\"] .option-desc,\nhtml[data-theme=\"dark\"] .terms-text,\nhtml[data-theme=\"dark\"] .project-info-label,\nhtml[data-theme=\"dark\"] .wallet-tab-btn,\nbody:not(.light_theme) .airdrops-hero-desc,\nbody:not(.light_theme) .airdrop-detail-desc,\nbody:not(.light_theme) .airdrop-desc,\nbody:not(.light_theme) .reward-label,\nbody:not(.light_theme) .timer-label,\nbody:not(.light_theme) .task-desc,\nbody:not(.light_theme) .wallet-modal-subtitle,\nbody:not(.light_theme) .option-desc,\nbody:not(.light_theme) .terms-text,\nbody:not(.light_theme) .project-info-label,\nbody:not(.light_theme) .wallet-tab-btn {\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .airdrop-card,\nhtml[data-theme=\"dark\"] .task-card,\nhtml[data-theme=\"dark\"] .wallet-option-box,\nhtml[data-theme=\"dark\"] .connect-option,\nhtml[data-theme=\"dark\"] .other-wallet-card,\nbody:not(.light_theme) .airdrop-card,\nbody:not(.light_theme) .task-card,\nbody:not(.light_theme) .wallet-option-box,\nbody:not(.light_theme) .connect-option,\nbody:not(.light_theme) .other-wallet-card {\n    background-color: #181a20;\n    border-color: #2b3139;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\nhtml[data-theme=\"dark\"] .wallet-modal-card,\nbody:not(.light_theme) .wallet-modal-card {\n    background-color: #181a2020;\n    border-color: #2b3139a6;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\nhtml[data-theme=\"dark\"] .airdrop-tab,\nbody:not(.light_theme) .airdrop-tab {\n    background-color: #2b3139;\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .airdrop-tab.active,\nhtml[data-theme=\"dark\"] .wallet-tab-btn.active,\nbody:not(.light_theme) .airdrop-tab.active,\nbody:not(.light_theme) .wallet-tab-btn.active {\n    background-color: #D3B06C;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .airdrop-tab:hover,\nbody:not(.light_theme) .airdrop-tab:hover {\n    background-color: #3b424a;\n}\n\nhtml[data-theme=\"dark\"] .wallet-tab-btn:hover,\nbody:not(.light_theme) .wallet-tab-btn:hover {\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .tag.tag-upcoming,\nhtml[data-theme=\"dark\"] .tag.tag-ended,\nbody:not(.light_theme) .tag.tag-upcoming,\nbody:not(.light_theme) .tag.tag-ended {\n    background-color: #2b3139;\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .timer-val,\nhtml[data-theme=\"dark\"] .footer-terms,\nbody:not(.light_theme) .timer-val,\nbody:not(.light_theme) .footer-terms {\n    background-color: #0d1219;\n    border-color: #2b3139;\n}\n\nhtml[data-theme=\"dark\"] .wallet-modal-close-btn,\nbody:not(.light_theme) .wallet-modal-close-btn {\n    background-color: #2b3139;\n    color: #a0aab5;\n}\n\nhtml[data-theme=\"dark\"] .wallet-modal-close-btn:hover,\nbody:not(.light_theme) .wallet-modal-close-btn:hover {\n    background-color: #3b424a;\n    color: #ffffff;\n}\n\nhtml[data-theme=\"dark\"] .wallet-modal-overlay,\nbody:not(.light_theme) .wallet-modal-overlay {\n    background-color: rgb(11 14 20 / 70%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
